import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { t } from 'utils';
import styles from './PlanBadge.module.scss';

export type Plan = 'PREMIUM' | 'CLASSIC' | 'ENTERPRISE';

export interface IPlanBadge extends HTMLAttributes<HTMLDivElement> {
  plan: Plan;
}

const PlanBadge: FC<IPlanBadge> = (props) => {
  const { className, plan } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.premium]: plan === 'PREMIUM',
    [styles.enterprise]: plan === 'ENTERPRISE',
  });

  return <div className={rootClassName}>{t(plan.toLocaleLowerCase())}</div>;
};

export default PlanBadge;
